import { render, staticRenderFns } from "./UploadImageInput.vue?vue&type=template&id=029ff600&scoped=true&"
import script from "./UploadImageInput.vue?vue&type=script&lang=js&"
export * from "./UploadImageInput.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageInput.vue?vue&type=style&index=0&id=029ff600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ff600",
  null
  
)

export default component.exports
import {QImg,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QIcon})
